export enum StepVariant {
  CHECKED = 'checked',
  DEFAULT = 'default',
  DISABLED = 'disabled',
}
